import React from "react";
import styled from "styled-components";
import { Box } from "../Box";
import { Icon } from "../Icon";
import { Link } from "../Link";
import { mediaQueries, style } from "../style";

type Feature = {
  description: React.ReactNode;
};

type Props = {
  title: React.ReactNode;
  description: React.ReactNode;
  imageUrl: string;
  features: Feature[];
  link: {
    text: string;
    to: string;
  };
};

type ContainerProps = {
  $centerAll: boolean;
};

const Container = styled.div<ContainerProps>`
  all: unset;

  display: flex;
  flex-direction: column;
  gap: ${style.vars.space[4]};

  text-align: ${(props) => (props.$centerAll ? "center" : undefined)};
`;

const Image = styled.img`
  all: unset;

  margin: 0 ${style.vars.space[5]};
  max-width: 100%;
`;

const Title = styled.h2`
  all: unset;

  font-size: ${style.vars.fontSize.larger};
  font-weight: ${style.vars.fontWeight.bold};
`;

const Description = styled.div`
  color: ${style.colors.grey.dark};
`;

const Features = styled.div`
  all: unset;

  display: flex;
  flex-direction: column;
  gap: ${style.vars.space[3]};
`;

export const CreatePageMarketing: React.FC<Props> = (props) => {
  const { title, description, imageUrl, link, features } = props;

  const mediumMax = mediaQueries.mediumMax.useMatchesBreakpoint();

  return (
    <Container $centerAll={mediumMax}>
      <Image src={imageUrl} alt="Marketing" />
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Features>
        {features.map((feature, index) => (
          <div key={index}>
            <Icon icon="check" green />
            <Box mr={4} />
            {feature.description}
          </div>
        ))}
      </Features>
      <div>
        <Link type="external" to={link.to}>
          {link.text}
        </Link>
      </div>
    </Container>
  );
};

CreatePageMarketing.displayName = "CreatePageMarketing";
